module.exports = __webpack_public_path__ + "static/img/chrome.21d0011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chrome.png
// module id = glcu
// module chunks = 1